module.exports = "<div md-whiteframe=\"1\" class=\"content-box text-center\">\n  <p><div logo></div></p>\n  <h1>{{ \"USERS.INSTALATOR_CONFIRMED.TITLE\" | translate }}</h1>\n  <h1>{{ \"USERS.INSTALATOR_CONFIRMED.SUBTITLE\" | translate }}</h1>\n  \n  <p>\n    <a class=\"md-button md-raised md-primary\" ui-sref=\"public.users.instalator.instalator-login\">\n      {{ \"COMMONS.NEXT\" | translate }}\n    </a>\n  </p>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/users/instalator/instalator-confirmed.html
// module id = 255
// module chunks = 0